import { useUserEmail } from '@/stores/user-store'
import { featureHubApiKey } from '@/utils/constants.ts'
import { FeatureHub } from 'featurehub-react-sdk'
import type React from 'react'

export const DantiFeatureHubProvider = ({
  children,
}: React.PropsWithChildren) => {
  const email = useUserEmail()

  return (
    <FeatureHub
      url="https://app.featurehub.io/vanilla"
      apiKey={featureHubApiKey}
      userKey={email}
      pollInterval={600000} // 10 minutes
    >
      {children as React.ReactElement}
    </FeatureHub>
  )
}
